import { Button, Card, Flex, message, Select, Space, Tag, Typography } from "antd"
import { ICustomer } from "../types/customers"
import { FC, useState } from "react"
import TitleCustomerCard from "./TitleCustomerCard"
import SelectAccessPage from "./SelectAccessPage"
import { editAccessesPagesToCustomer } from "../api/customersApi"
import EditUser from "./EditUser"

const { Text } = Typography

interface ICustomerCard {
  customer: ICustomer
}

const CustomerCard: FC<ICustomerCard> = ({ customer }) => {
  const [accessesPage, setAccessesPage] = useState<[string]>(customer.accessesPages)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  function saveChanges() {
    setIsLoading(true)

    editAccessesPagesToCustomer(customer._id, accessesPage)
      .then((res) => {
        message.success("Saved successfully")
      })
      .catch((e) => {
        message.error("Save failed")
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <Card
      title={<TitleCustomerCard fullName={customer.fullName} roles={customer.roles} />}
      style={{ minWidth: "33%" }}
    >
      <Flex vertical gap="10px">
        <Text copyable={{ text: customer.email }}>email: {customer.email}</Text>

        <Space>
          Access pages:{" "}
          {customer.accessesPages.map((page) => (
            <Tag key={page} color="purple">
              {page}
            </Tag>
          ))}
        </Space>

        <Flex justify="flex-end">
          <EditUser customer={customer} />
        </Flex>
      </Flex>
    </Card>
  )
}

export default CustomerCard
